import { Link } from "react-router-dom";
import { CatalogHero, CatalogLayout } from "../components/catalog";

export function NotFoundPage() {
  return (
    <CatalogLayout title="Page not found">
      <CatalogHero
        label="404"
        title="Page not found"
        intro="This page is no longer available. Explore the current product catalog or return to the home page."
      />
      <section className="catalog-wrap catalog-section">
        <Link className="catalog-button" to="/products">
          Explore products
        </Link>
      </section>
    </CatalogLayout>
  );
}
